import download from "js-file-download";
import { Loading, Message, MessageBox } from 'element-ui';
/**
 * 格式化时间 yyyy-M-d H:mm:s
 * @param {Boolean} isHMS 是否需要时分秒 默认true需要
 * @param {String} ymdDivision 年月日分割符 默认 -
 * @param {String} hmsDivision 时分秒分隔符 默认 :
 * @returns 时间格式
 */

Date.prototype.toDate = function (isHMS = true, ymdDivision = '-', hmsDivision = ':') {
    let y = this.getFullYear();
    let M = this.getMonth() + 1;
    let d = this.getDate();
    let hms = '';
    if (isHMS) {
        let h = this.getHours();
        let m = this.getMinutes();
        let s = this.getSeconds();
        hms = ` ${h + hmsDivision + (m > 10 ? m : "0" + m) + hmsDivision + s}`;
    }
    return `${y + ymdDivision + M + ymdDivision + d}${hms}`;
}

// vuescroll配置
const scrollOps = {
    bar: {
        background: '#6c757d'
    }
}

/**
 * 三级联动
 * @param {Object} (array: Array, NoLabel: String, No: String)
 * @returns {Array} Array<String, any>
 */
function linkage({ array, NoLabel, No }) {
    let result = [];
    for (let i = 0; i < array.length; i++) {
        if (array[i][NoLabel] === No) {
            result.push(array[i]);
        }
    }
    return result;
}

const exportFile = async ({ method, url, data }) => {
  let loadingInstance = Loading.service()
  try {
    console.log('url', url)
    let response = await axios({
      method,
      responseType: "blob",
      url,
      data
    });

    console.log('response', response)

    let fileName = response.headers["content-disposition"].split("''")[1];
    if(!fileName) {
      fileName = response.headers["content-disposition"].split("=")[1];
    }
    fileName = decodeURI(fileName);

    let res = response.data;
    const blob = new Blob([res], { type: "application/vnd.ms-excel" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(a.href);
    a.remove();
    return { data: response, fileName };
  }
  catch (e) {
    let res = await axios({
      method,
      url,
      data
    });
    if (res.data.code !== 200 && res.data.code !== 403) {
      let errorMsg = res.data.message || res.data.msg
      Message.warning({
        message: errorMsg || '操作失败'
      })
    }
  }
  finally {
    loadingInstance.close();
  }
}

export default {
    exportFile,
    scrollOps,
    linkage
}


/**
 * 下载文件
 * url: 下载的文件地址
 * name: 下载的文件的名字
 */
export const downloadFile = async function (url, name) {
  const result = await window.axios.get(url, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  })
  download(result.data, name)
}







// WEBPACK FOOTER //
// ./src/vms/utils/tool.js